import { useLocation, useNavigate } from "react-router-dom";
import { useAcceptEventSubmission, useGetEventSubmissionDetailsById, useRejectEventSubmission } from "../../queries/event";
import { ActionButton } from "../../components/Forms/ActionButton";
import { useEffect, useState } from "react";
import Modal from "../Submissions/components/Modal";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { formatDateTime } from "../../utils/formatters/dateTimeFormat";
import Chip from "../../components/Chip";
import MediaUpload from "../../components/Forms/MediaUpload";

const EventSubmissionsDetails = () => {

    const navigate = useNavigate();

    const { state } = useLocation();
    const eventSubmissionId = state?.eventSubmissionId;

    const [acceptModel, setAcceptModel] = useState(false);
    const [userModal, setUserModel] = useState(false);
    const [referredByUserModal, setReferredByUserModel] = useState(false);
    const [eventModal, setEventModal] = useState(false);
    const [rejectModel, setRejectModel] = useState(false);
    const [points, setPoints] = useState(0);
    const [remarks, setRemarks] = useState('');
    const [coverImage, setCoverImage] = useState(null);
    const [clearMedia, setClearMedia] = useState(false);

    const { data, isPending } = useGetEventSubmissionDetailsById(eventSubmissionId);

    const [disabledControl, setDisabledControl] = useState(data?.eventSubmissions?.reviewDate === null ? false : true);

    const [selectedTab, setSelectedTab] = useState('certificate');

    const { mutateAsync: accept, isPending: isAccepting } = useAcceptEventSubmission(eventSubmissionId);
    const { mutateAsync: reject, isPending: isRejecting } = useRejectEventSubmission(eventSubmissionId);

    const handleAccept = async () => {
        accept({
            eventSubmissionId: eventSubmissionId,
            points: points,
            remarks: remarks,
            certificate: coverImage,
        }, {
            onSuccess: () => {
                setAcceptModel(false);
                toast.success('Event Submission Accepted');
                setTimeout(() => {
                    navigate('/events/events-submissions');
                }, 2000);
            },
            onError: (error) => {
                console.log(error);
            }
        });
    }

    const handleReject = async () => {
        reject({
            eventSubmissionId: eventSubmissionId,
            remarks: remarks
        }, {
            onSuccess: () => {
                setRejectModel(false);
                toast.success('Event Submission Rejected');
                setTimeout(() => {
                    navigate('/events/events-submissions');
                }, 2000);
            },
            onError: (error) => {
                console.log(error);
            }
        });
    }

    useEffect(() => {
        if (data) {
            console.log(data?.eventSubmissions?.allocatedPoints);
            setPoints(data?.eventSubmissions?.allocatedPoints || data?.event?.points);
            setDisabledControl((data?.eventSubmissions?.reviewDate !== null || data?.eventSubmissions?.submissionDate === null) ? true : false);
            setTimeout(() => {
                setCoverImage(data?.eventSubmissions?.eventCertificate[0] || null);
            }, 500);
        }
    }, [data]);

    if (isPending) {
        return <div>Loading...</div>
    }

    const renderCurrentPage = () => {
        if (selectedTab === 'certificate') {
            return (
                <div className='h-fit my-5 flex flex-col gap-2 bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] px-3 py-3 pb-5 basis-1/2 grow'>
                    <h1 className="text-primary text-xl">Certificate</h1>
                    <div className="flex flex-wrap gap-3 w-full min-h-[200px]">
                        <MediaUpload
                            clearMedia={clearMedia}
                            stateImage={coverImage}
                            setStateImageUpload={setCoverImage}
                            existingImage={coverImage}
                            setImageUpload={setCoverImage}
                            hideBtns={disabledControl}
                        />
                        {
                            data?.eventSubmissions?.eventCertificate?.length === 0 && (
                                <p className="w-full">No certificates submitted.</p>
                            )
                        }
                    </div>
                </div>
            );
        }
        else if (selectedTab === 'images') {
            return (
                <div className='h-fit my-5 flex flex-col gap-2 bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] px-3 py-3 basis-1/2 grow'>
                    <h1 className="text-primary text-xl">Event Photos</h1>
                    <div className="flex flex-wrap gap-3 w-full min-h-[200px]">
                        {
                            data?.eventSubmissions?.eventPhotos?.length > 0 ? (
                                data?.eventSubmissions?.eventPhotos.map((item, index) => (
                                    <div className="relative">
                                        <img key={index} src={item} className="w-96 h-96 object-cover" alt={`Photo ${index + 1}`} />
                                        <button
                                            className="absolute bottom-0 w-full bg-black opacity-70 text-white py-1 rounded hover:bg-primaryHoverDark transition-colors"
                                            onClick={() => {
                                                window.open(item, '_blank');
                                            }}
                                        >
                                            View
                                        </button>
                                    </div>
                                ))
                            ) : (
                                <p className="w-full">No photos submitted.</p>
                            )
                        }
                    </div>
                </div>
            );
        }
        else if (selectedTab === 'video') {
            return (
                <div className='h-fit my-5 flex flex-col gap-2 bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] px-3 py-3 basis-1/2 grow'>
                    <h1 className="text-primary text-xl">Event Video</h1>
                    <div className="flex flex-wrap gap-3 w-full min-h-[200px]">
                        {
                            data?.eventSubmissions?.eventVideo?.length > 0 ? (
                                data?.eventSubmissions?.eventVideo.map((item, index) => (
                                    <video key={index} src={item} className="w-96 h-96" controls>
                                        Your browser does not support the video tag.
                                    </video>
                                ))
                            ) : (
                                <p className="w-full">No event video submitted.</p>
                            )
                        }
                    </div>
                </div>
            );
        }
    }

    return (
        <div className="flex flex-col text-base font-semibold text-gray-900 rounded mr-0">
            {/* Accept */}
            <Modal isOpen={acceptModel} onClose={() => setAcceptModel(false)}>
                <h1>Do you really want to Approve?</h1>
                <div className="flex flex-col items-start justify-end gap-3 mt-5">
                    <p>Points</p>
                    <input
                        type="number"
                        className="border border-border rounded-md p-2 w-full"
                        value={points}
                        onChange={(e) => setPoints(e.target.value)}
                    />
                </div>
                <div className="flex flex-col items-start justify-end gap-3 mt-5">
                    <p>Remarks</p>
                    <textarea
                        className="border border-border rounded-md p-2 w-full"
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                    />
                </div>
                <div className="flex items-center justify-center gap-3 mt-5">
                    <ActionButton
                        text={'No'}
                        variant={'cancel'}
                        disabled={isAccepting}
                        handleSubmit={() => setAcceptModel(false)}
                    />
                    <ActionButton
                        text={isAccepting ? 'Accepting...' : 'Yes'}
                        variant={'submit'}
                        disabled={isAccepting}
                        handleSubmit={() => handleAccept()}
                    />
                </div>
            </Modal>
            {/* Reject */}
            <Modal isOpen={rejectModel} onClose={() => setRejectModel(false)} >
                <h1>Do you really want to Reject?</h1>
                <div className="flex flex-col items-start justify-end gap-3 mt-5">
                    <p>Remarks</p>
                    <textarea
                        className="border border-gray-300 rounded-md p-2 w-full"
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                    />
                </div>
                <div className="flex items-center justify-center gap-3 mt-5">
                    <ActionButton
                        text={'No'}
                        variant={'cancel'}
                        disabled={isRejecting}
                        handleSubmit={() => setRejectModel(false)}
                    />
                    <ActionButton
                        text={isRejecting ? 'Rejecting...' : 'Yes'}
                        variant={'submit'}
                        disabled={isRejecting}
                        handleSubmit={handleReject}
                    />
                </div>
            </Modal>
            {/* User details model */}
            <Modal isOpen={userModal} onClose={() => setUserModel(false)}>
                <div>
                    <h1 className="text-primary font-bold text-xl">User Details</h1>
                    <div className="flex flex-col gap-3 pt-3">
                        <p className="inline-flex">Username: {data?.user?.profilepic && <img src={data?.user?.profilepic} className="size-5 rounded-full mx-2" alt="" />}{data?.user?.username}</p>
                        <p>Email: {data?.user?.email}</p>
                        <p>Phone: {data?.user?.mobile}</p>
                        <p>Challenges Participated: {data?.user?.challengesParticipated.length}</p>
                        <p>Events Participated: {data?.user?.events.length}</p>
                        <p>Blogs Published: {data?.user?.blogs.length}</p>
                        <p>Total Points Collected: {data?.user?.points}</p>
                    </div>
                </div>
            </Modal>
            {/* Referred by User details model */}
            <Modal isOpen={referredByUserModal} onClose={() => setReferredByUserModel(false)}>
                <div>
                    <h1 className="text-primary font-bold text-xl">Referred by User Details</h1>
                    <div className="flex flex-col gap-3 pt-3">
                        <p className="inline-flex">Username: {data?.eventSubmissions?.isInvited?.invitedBy.profilepic && <img src={data?.eventSubmissions?.isInvited?.invitedBy?.profilepic} className="size-5 rounded-full mx-2" alt="-" />}{data?.eventSubmissions?.isInvited?.invitedBy?.username}</p>
                        <p>Email: {data?.eventSubmissions?.isInvited?.invitedBy?.email}</p>
                        <p>Phone: {data?.eventSubmissions?.isInvited?.invitedBy?.mobile}</p>
                        <p>Challenges Participated: {data?.eventSubmissions?.isInvited?.invitedBy?.challengesParticipated.length}</p>
                        <p>Events Participated: {data?.eventSubmissions?.isInvited?.invitedBy?.events.length}</p>
                        <p>Total Points Collected: {data?.eventSubmissions?.isInvited?.invitedBy?.points}</p>
                    </div>
                </div>
            </Modal>
            {/* Event details model */}
            <Modal isOpen={eventModal} onClose={() => setEventModal(false)}>
                <div className="flex flex-row items-start justify-between gap-3">
                    <div>
                        <h2 className="text-xl font-bold mb-4">Event Details</h2>
                        <div className="flex flex-wrap gap-5">
                            <div className="mt-1 flex gap-2">
                                <p className="font-semibold">Event Name:</p>
                                <p className="font-normal capitalize">{data && data?.event?.title}</p>
                            </div>
                            <div className="mt-1 flex gap-2 basis-1/2">
                                <p className="font-semibold">Event Category:</p>
                                <p className="font-normal capitalize">{data && data?.event?.typeOfEvent?.name}</p>
                            </div>
                            <div className="flex w-auto gap-32 items-center justify-between">
                                <div className="mt-1 flex gap-2 grow">
                                    <p className="font-semibold">Start Date:</p>
                                    <p className="font-normal capitalize">{data && data?.event?.startDate.toRegularDate()}</p>
                                </div>
                                <div className="mt-1 flex gap-2 grow">
                                    <p className="font-semibold">End Date:</p>
                                    <p className="font-normal capitalize">{data && data?.event?.endDate.toRegularDate()}</p>
                                </div>
                            </div>
                            <div className="mt-1 flex gap-2 basis-1/2">
                                <p className="font-semibold">Creation Date</p>
                                <p className="font-normal capitalize">{data && data?.event?.createdAt.toRegularDate()}</p>
                            </div>
                            <div className="mt-1 flex gap-2 basis-1/2">
                                <p className="font-semibold">City:</p>
                                <p className="font-normal capitalize">
                                    {data && (typeof data?.event?.city === 'string' ? data?.event?.city : data?.event?.city?.name || '')}
                                </p>
                            </div>
                            <div className="mt-1 flex gap-2 basis-1/2">
                                <p className="font-semibold">Event Location:</p>
                                <p className="font-normal capitalize">{data && data?.event?.location}</p>
                            </div>
                            <div className="mt-1 flex gap-2 basis-1/2">
                                <p className="font-semibold">Certificate Arrangement:</p>
                                <p className="font-normal capitalize">{data && data?.event?.certificateArrangement}</p>
                            </div>
                            <div className="mt-1 flex gap-2 basis-1/2">
                                <p className="font-semibold">Event Organiser:</p>
                                <p className="font-normal capitalize">{data && data?.event?.eventOrganiser?.ngoId ? data?.event?.eventOrganiser?.ngoId.ngoName : data?.event?.eventOrganiser?.companyId?.companyName}</p>
                            </div>
                            <div className="mt-1 flex gap-2 basis-1/2">
                                <p className="font-semibold">Timing Details:</p>
                                <p className="font-normal capitalize">{data && data?.event?.timingDetails}</p>
                            </div>
                            {/* <div className="mt-1 flex gap-2 basis-1/2">
                                <p className="font-semibold">Sponsor</p>
                                <p className="font-normal capitalize">{data && data?.event?.eventSponsor || "-"}</p>
                            </div> */}
                            {
                                data && data?.event?.venueMapUrl && (
                                    <div className="mt-1 flex grow gap-2 basis-1/2">
                                        <p className="font-semibold">Venue Map Url</p>
                                        <a className="font-normal text-chipBlue capitalize" href={data?.event?.venueMapUrl} target="_blank" rel="noopener noreferrer">{data && data?.event?.venueMapUrl}</a>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    <img src={data?.event?.coverImage} className="max-w-96 h-auto" alt="event" />
                </div>
            </Modal>
            <div className="bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full p-3">
                <div className="flex justify-between items-center">
                    <h1
                        className="gap-2.5 w-full font-bold max-md:max-w-full text-primary capitalize cursor-pointer"
                        onClick={() => setEventModal(true)}
                    >
                        <span className="text-black">Submitted Event:</span> <span title="Event Category">{data.event.typeOfEvent?.name}</span> | <span title="Event Name">{data.event.title}</span>
                    </h1>
                    <div className="flex gap-2 items-center">
                        <p className="inline-flex">Verification:</p>
                        <Chip value={(data.eventSubmissions.reviewDate && data.eventSubmissions.allocatedPoints > 0) ? 'Accepted' : (data.eventSubmissions.reviewDate && data.eventSubmissions.allocatedPoints < 0) ? 'Rejected' : 'Pending'} color={data.eventSubmissions.reviewDate ? 'green' : 'red'} />
                        {
                            data.eventSubmissions.reviewDate !== null &&
                            <div className='flex gap-2 basis-1/12'>
                                <p
                                    className={`font-bold px-4 py-1 rounded cursor-pointer ${disabledControl ? 'bg-primary' : 'bg-navBtn'} ${disabledControl ? 'text-white' : 'text-secondary'}`}
                                    onClick={() => {
                                        setDisabledControl(!disabledControl);
                                    }}
                                >Edit</p>
                            </div>
                        }
                    </div>
                </div>
                <div className="mt-5 flex flex-wrap gap-5">
                    <div className="flex gap-2 basis-1/5">
                        <p className="font-semibold ">Submitted By:</p>
                        <p className="capitalize cursor-pointer text-primary font-bold" onClick={() => setUserModel(true)}>{data.user.username}</p>
                    </div>
                    <div className="flex gap-2 basis-1/4">
                        <p className="font-semibold ">Submitted On:</p>
                        <p className="text-primary font-bold">
                            {data.eventSubmissions?.submissionDate?.toRegularDateTime() || "Yet to submit"}
                        </p>
                    </div>
                    <div className="flex gap-2 basis-1/4">
                        <p className="font-semibold ">Attended On:</p>
                        <p className="text-primary font-bold">
                            {data.eventSubmissions?.attendedDate?.toRegularDate() || "Yet to attend"}
                        </p>
                    </div>
                    {
                        data?.eventSubmissions?.isInvited && (
                            <div className="flex gap-2 basis-1/4">
                                <p className="font-semibold ">Referred By:</p>
                                <p className="text-primary cursor-pointer font-bold" onClick={() => setReferredByUserModel(true)}>
                                    {data?.eventSubmissions?.isInvited?.invitedBy?.username || "Not referred"}
                                </p>
                            </div>
                        )
                    }
                </div>
                <div className="mt-5 flex flex-wrap gap-5">
                    <div className="flex gap-2 basis-1/5">
                        <p className="font-semibold ">Event Points:</p>
                        <p className="capitalize text-primary font-bold">{data.event.points}</p>
                    </div>
                    <div className="flex gap-2 basis-1/3">
                        <p className="font-semibold ">Earned Event Points:</p>
                        <p className="capitalize text-primary font-bold">{data.eventSubmissions.allocatedPoints ? data.eventSubmissions.allocatedPoints : 0}</p>
                    </div>
                </div>
            </div>

            <div className="flex w-full justify-between gap-2">
                <div className='h-fit my-5 flex flex-col gap-2 basis-1/5 bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] px-3 py-3'>
                    <h1 className="text-primary text-xl">Pages to be checked:</h1>
                    <button
                        className={`font-bold text-base rounded-md py-2 border-2 ${selectedTab === 'certificate' ? 'bg-white' : 'bg-navBtn'} ${selectedTab === 'certificate' ? 'border-primary' : 'border-navBtn'}`}
                        onClick={() => setSelectedTab('certificate')}
                    >
                        Certificate
                    </button>
                    <button
                        className={`font-bold text-base rounded-md py-2 border-2 ${selectedTab === 'images' ? 'bg-white' : 'bg-navBtn'} ${selectedTab === 'images' ? 'border-primary' : 'border-navBtn'}`}
                        onClick={() => setSelectedTab('images')}
                    >
                        Event Photos
                    </button>
                    <button
                        className={`font-bold text-base rounded-md py-2 border-2 ${selectedTab === 'video' ? 'bg-white' : 'bg-navBtn'} ${selectedTab === 'video' ? 'border-primary' : 'border-navBtn'}`}
                        onClick={() => setSelectedTab('video')}
                    >
                        Event Video
                    </button>
                </div>
                {renderCurrentPage()}
            </div>

            <div className={`flex items-center justify-end gap-3 mt-5 ${disabledControl ? 'pointer-events-none cursor-not-allowed opacity-40' : ''}`}>
                {
                    !data?.eventSubmissions?.reviewDate && (
                        <ActionButton
                            text={'Reject'}
                            variant={'cancel'}
                            disabled={disabledControl}
                            handleSubmit={() => setRejectModel(true)}
                        />
                    )
                }
                <ActionButton
                    text={data?.eventSubmissions?.reviewDate ? 'Save' : 'Accept'}
                    variant={'submit'}
                    disabled={disabledControl}
                    handleSubmit={() => setAcceptModel(true)}
                />
            </div>

            <ToastContainer
                position="top-right"
            />
        </div>
    )
}

export default EventSubmissionsDetails;